<!-- DownloadFileButton.vue -->
<template>
    <v-btn
        size="large"
        variant="flat"
        color="primary"
        @click="downloadFile"
        icon="mdi-file-download"
    >
        <v-icon>mdi-file-download</v-icon>
        <v-tooltip :text="tooltipText" location="top" activator="parent" />
    </v-btn>
</template>

<script>
export default {
    name: "DownloadFileButton",
    props: {
        tooltipText: { type: String, required: true },
        document: { type: String, required: true },
        multiLang: { type: Boolean, default: false },
    },
    computed: {
        lang() {
            return this.$i18n.locale.split("-")[0];
        },
        baseUrl() {
            return (process.env.VUE_APP_API_URL || "").replace(/\/api\/?$/, "");
        },
        enUrl() {
            return `${this.baseUrl}/media/register_contracts/${this.document}_en.pdf`;
        },
        enName() {
            return `${this.document}_en.pdf`;
        },
        langUrl() {
            return `${this.baseUrl}/media/register_contracts/${this.document}_${this.lang}.pdf`;
        },
        langName() {
            return `${this.document}_${this.lang}.pdf`;
        },
    },

    methods: {
        async downloadFile() {
            if (!this.multiLang || this.lang === "en") {
                this.open(this.enUrl, this.enName);
                return;
            }

            try {
                const head = await fetch(this.langUrl, { method: "HEAD" });
                if (head.ok) {
                    this.open(this.langUrl, this.langName);
                    return;
                }
            } catch (_) {
                /* network error – ignore */
            }

            this.open(this.enUrl, this.enName);
        },

        open(url, name) {
            const link = document.createElement("a");
            link.href = url;
            link.download = name;
            link.target = "_blank";
            link.rel = "noopener";
            link.click();
            link.remove();
        },
    },
};
</script>
